/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react';
import { Input } from 'app/components/ui/input';
import { Button } from 'app/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'app/components/ui/select';
import { Star, Search, ThumbsUp, ThumbsDown } from 'lucide-react';
import { useCourseSlice } from '../../Course/slice';
import { formatDistanceToNow } from 'date-fns';
import { useDispatch } from 'react-redux';
import { useCourseDetailsSlice } from '../slice';
import RatingStats from '../components/review-stats';
import { useParams } from 'react-router-dom';
import Layout from '../components/layout';

const CourseReviews = () => {
  const { useCourseReviewsQuery } = useCourseDetailsSlice();
  const [getCourseReviews, { data: reviews, error, isLoading }] =
    useCourseReviewsQuery();
  const { courseId } = useParams();

  React.useEffect(() => {
    if (courseId) {
      getCourseReviews(courseId);
    }
  }, [courseId]);

  return (
    <Layout>
      <div className="min-h-screen">
        <section className="max-w-5xl mx-auto mb-2">
          <h2 className="text-2xl font-semibold mb-4">Student feedback</h2>
          {isLoading && <p className="text-center mt-5">Loading...</p>}

          {reviews?.data?.length > 0 && (
            <RatingStats aggregates={reviews?.aggregates} />
          )}
        </section>

        {/* Review List */}
        {reviews?.data?.map((review, index) => (
          <div className="border-t pt-6">
            <div className="flex items-start gap-4 mb-6">
              {/* User Avatar */}
              <div className="flex items-center justify-center bg-gray-200 h-12 w-12 rounded-full text-lg font-medium uppercase">
                {review?.first_name && review?.last_name
                  ? `${review?.first_name[0]}${review?.last_name[0]}`
                  : review?.email?.substring(0, 2)}
              </div>
              {/* Review Content */}
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="font-semibold text-md">
                    {review?.first_name && review?.last_name
                      ? `${review?.first_name} ${review?.last_name}`
                      : review?.email?.split('@')[0]}
                  </h4>
                  <span className="text-sm text-gray-500">
                    <time dateTime={formatDistanceToNow(review?.created_at)}>
                      {formatDistanceToNow(review?.created_at)} ago
                    </time>
                  </span>
                </div>
                <div className="flex items-center gap-1 text-orange-500">
                  {review?.rating &&
                    [...Array(review?.rating)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-current" />
                    ))}
                </div>
                <p className="mt-2 text-gray-700 text-[14px] leading-loose">
                  {review?.comment}
                </p>
                {/* Feedback Actions */}
                <div className="flex items-center gap-4 mt-4 text-gray-600 hidden">
                  <button className="flex items-center gap-1 text-sm hover:text-gray-800">
                    <ThumbsUp className="h-4 w-4" /> Yes
                  </button>
                  <button className="flex items-center gap-1 text-sm hover:text-gray-800">
                    <ThumbsDown className="h-4 w-4" /> No
                  </button>
                  <button className="text-sm hover:text-gray-800">
                    Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default CourseReviews;
